import { render, staticRenderFns } from "./ReportDispatchSales.vue?vue&type=template&id=3881c489&scoped=true&"
import script from "./ReportDispatchSales.vue?vue&type=script&lang=js&"
export * from "./ReportDispatchSales.vue?vue&type=script&lang=js&"
import style0 from "./ReportDispatchSales.vue?vue&type=style&index=0&id=3881c489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881c489",
  null
  
)

export default component.exports